import { useState } from "react";

function CopyableLinkFullWidth({ label, url }: { label: string; url: string }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(url)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {
        // manejar error si quieres
      });
  };

  return (
    <div className="w-full bg-gray-100 rounded p-4 relative select-text">
      {/* Botón copy/copyed en la esquina superior derecha */}
      <button
        onClick={handleCopy}
        type="button"
        aria-label={`Copiar valor de ${label}`}
        className="absolute top-2 right-2 flex items-center space-x-1 px-2 py-1 text-[10px] font-medium text-gray-700 bg-gray-300 rounded hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-500"
        title={copied ? "Copiado" : "Copiar URL"}
      >
        {!copied ? (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <rect x="9" y="9" width="12" height="12" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="3" y="3" width="12" height="12" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        )}
        <span>{copied ? "Copied" : "Copy"}</span>
      </button>

      {/* Label encima del link */}
      <p className="mb-1 font-semibold text-black select-none">{label}</p>

      {/* URL en nueva línea con estilo link */}
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="block text-blue-600 underline break-words text-[10px]"
      >
        {url}
      </a>
    </div>
  );
}

export default CopyableLinkFullWidth;
